import React, { useState } from "react";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressBar } from "primereact/progressbar";
import { Card } from "primereact/card";
import { Steps } from "primereact/steps";
import "./index.scss";

const BulkProcessing = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [processingStatus, setProcessingStatus] = useState("idle");
  const [processedRecords, setProcessedRecords] = useState([]);

  const steps = [
    { label: "Upload File" },
    { label: "Validate" },
    { label: "Process" },
    { label: "Complete" }
  ];

  const validationResults = [
    { field: "Policy Number", valid: 98, invalid: 2, total: 100 },
    { field: "Premium Amount", valid: 95, invalid: 5, total: 100 },
    { field: "Transaction Date", valid: 100, invalid: 0, total: 100 },
  ];

  const handleUpload = (e) => {
    setUploadedFile(e.files[0]);
    setActiveIndex(1);
  };

  const handleProcess = () => {
    setProcessingStatus("processing");
    setTimeout(() => {
      setProcessingStatus("complete");
      setActiveIndex(3);
    }, 3000);
  };

  return (
    <div className="bulk-processing">
      <h2>Bulk Remittance Processing</h2>
      
      <Steps model={steps} activeIndex={activeIndex} className="mb-4" />

      <Card>
        {activeIndex === 0 && (
          <div className="upload-section">
            <FileUpload
              name="bulkFile"
              customUpload
              uploadHandler={handleUpload}
              accept=".csv,.xlsx"
              maxFileSize={50000000}
              emptyTemplate={<p>Drag and drop files here to upload.</p>}
            />
          </div>
        )}

        {activeIndex === 1 && (
          <div className="validation-section">
            <h3>Validation Results</h3>
            <DataTable value={validationResults}>
              <Column field="field" header="Field" />
              <Column field="valid" header="Valid" />
              <Column field="invalid" header="Invalid" />
              <Column field="total" header="Total" />
            </DataTable>
            <div className="mt-3">
              <Button label="Back" onClick={() => setActiveIndex(0)} className="p-button-secondary mr-2" />
              <Button label="Process" onClick={() => setActiveIndex(2)} className="p-button-primary" />
            </div>
          </div>
        )}

        {activeIndex === 2 && (
          <div className="processing-section">
            <h3>Processing Records</h3>
            <ProgressBar mode="indeterminate" style={{ height: "6px" }} />
            <p className="mt-3">Processing 100 records...</p>
            <Button label="Start Processing" onClick={handleProcess} className="p-button-success mt-3" />
          </div>
        )}

        {activeIndex === 3 && (
          <div className="complete-section">
            <h3>Processing Complete</h3>
            <div className="summary">
              <p>✅ Successfully processed: 93 records</p>
              <p>⚠️ Failed: 7 records</p>
            </div>
            <Button label="Download Report" icon="pi pi-download" className="p-button-primary mt-3" />
          </div>
        )}
      </Card>
    </div>
  );
};

export default BulkProcessing;
